import { Translation } from "@ha/data/basic";
import { Observable } from "rxjs";

import { AnswerTypeConfiguration, QuestionAnswerType } from "./question.model";
import { SafetyRule } from "./safety-rule";

export interface FixedTemplate {
    id: number;
    checkpoints: Checkpoint[];
    questions: Question[];
    flammableAtexQuestion: Question;
    flammableMaterialsQuestions?: Question[];
    atexQuestions?: Question[];
    safetyEquipmentQuestions?: Question[];
    gasFreeCertQuestions?: Question[];
    workMethods: WorkMethod[];
    safetyRules: SafetyRule[];
    emergencyLocation: SpecialStepInformation;
    fireAlarm: SpecialStepInformation;
    workMethodsSettings: StepPhotoAndCommentSettings;
}

export interface Checkpoint {
    ruleId: number;
    name: string;
    translations: Translation[];
    requirements: Requirement[];
}

export interface Requirement {
    answer: QuestionAnswerEnum;
    questions: QuestionRequirement[];
    workMethods: WorkMethodRequirement[];
    fireWatcher?: boolean;
    postFireWatcher?: boolean;
    fireAlarm?: boolean;
}

export enum QuestionAnswerEnum {
    Yes = 1,
    No = 2,
    NotApplicable = 4,
    Condition = 8,
}

export interface QuestionRequirement {
    questionId: number;
    answer: QuestionAnswerEnum;
}

export interface WorkMethodRequirement {
    workMethodId: number;
    ifSelected: boolean;
}

export interface Question {
    id: number;
    isPreparatory: boolean;
    translations: Translation[];
    help?: Translation[];
    alert: Alert;
    questionPrerequisite: QuestionPrerequisite;
    workMethodPrerequisites: number[];
    safetyRuleIds: number[];
    safetyRules?: SafetyRule[];
    photo: boolean;
    comment: boolean;
    triggersAtex?: boolean;
    showsGasFreeCertification?: boolean;
    answerType: QuestionAnswerType;
    answerTypeConfiguration?: AnswerTypeConfiguration;
}

export interface QuestionPrerequisite {
    questionId: number;
    requiredAnswerIsYes: boolean;
}

export interface WorkMethod {
    id: number;
    alert?: Alert;
    translations: Translation[];
    safetyRuleIds?: number[];
    safetyRules?: SafetyRule[];
    isFreeText: boolean;
    isSelected$?: Observable<boolean>;
}

export interface Alert {
    answerIsYes: boolean;
    answerIsNo: boolean;
    translations: Translation[];
    placeholder?: Placeholder;
    confirmToProceed: boolean;
    proceedNotAllowed: boolean;
}

/**
 * For example EmergencyLocation and FireAlarm
 *
 * @export
 * @interface SpecialStepInformation
 */
export interface SpecialStepInformation {
    translations: Translation[];
    alert: Alert;
    safetyRuleIds: number[];
    safetyRules: SafetyRule[];
    photo: boolean;
    comment: boolean;
}

export interface Placeholder {
    translations: Translation[];
}

export interface StepPhotoAndCommentSettings {
    photo: boolean;
    comment: boolean;
}
